import React, { useState } from 'react'
import type { GestureResponderEvent } from 'react-native'

import { Icon } from '~/components/icon'

import type { ILabelProps, ISingleFilterProps } from '../../types'

import * as S from './index.styles'

export function SingleFilter(props: ISingleFilterProps) {
  const {
    readOnly = false,
    selected = false,
    size = 'md',
    onPressIn,
    onPressOut,
    children,
    checked,
    disabled = false,
  } = props
  const defaultProps = {
    readOnly,
    selected,
    disabled,
    checked,
    size,
    type: 'singleFilter',
  }
  const [isPressed, setIsPressed] = useState(false)
  const isDisabled = disabled ?? readOnly

  function handlePressIn(event: GestureResponderEvent) {
    setIsPressed(true)
    onPressIn?.(event)
  }

  function handlePressOut(event: GestureResponderEvent) {
    setIsPressed(false)
    onPressOut?.(event)
  }

  return (
    <S.Root
      {...props}
      {...defaultProps}
      {...{ isPressed }}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
    >
      {checked && (
        <Icon
          size={size === 'md' ? 'extra-small' : 'small'}
          symbol="rdicon-checkmark"
          color={
            isDisabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'
          }
        />
      )}

      <S.LabelContainer>
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(
              child,
              defaultProps as unknown as ILabelProps
            )
          }
          return child
        })}
      </S.LabelContainer>
    </S.Root>
  )
}
